export const initEcommerceVisitorSegmentData = function () {
    return {
        data: {
            id: '',
            campaign_setting_id: '',
            visitor_type: 'newVisitor',
            visitor_member_type: 'newMember',
            visitor_gender: 'both',
            visitor_behavior_type: 'all'
        },
        fieldConfigurations: {
            visitor_type: {
                placeholder: '',
                name: 'visitor_type',
                label: 'Visitor Type',

                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: 'Visitor type is required.'
                    }
                },
                options: [
                    {
                        label: 'New visitor',
                        value: 'newVisitor'
                    },
                    {
                        label: 'Returning visitor',
                        value: 'returningVisitor'
                    },
                    {
                        label: 'All',
                        value: 'all'
                    }
                ]
            },
            returning_visitor_type: {
                placeholder: '',
                name: 'returning_visitor_type',
                label: 'Returning Visitor Type',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: 'Visitor membership is required.'
                    }
                },
                options: [
                    {
                        label: 'Browsers',
                        value: 'newMember'
                    },
                    {
                        label: 'Prospects',
                        value: 'newMember'
                    },
                    {
                        label: 'One Time Purchaser',
                        value: 'newMember'
                    },
                    {
                        label: 'Repeat Purchasers',
                        value: 'returningMember'
                    },
                    {
                        label: 'Loyal Customers',
                        value: 'returningMember'
                    },
                    {
                        label: 'All',
                        value: 'both'
                    }
                ]
            },
            visitor_member_type: {
                placeholder: '',
                name: 'visitor_member_type',
                label: 'Visitor Membership',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: 'Visitor membership is required.'
                    }
                },
                options: [
                    {
                        label: 'New Member',
                        value: 'newMember'
                    },
                    {
                        label: 'Returning member',
                        value: 'returningMember'
                    },
                    {
                        label: 'Both',
                        value: 'both'
                    }
                ]
            },
            visitor_gender: {
                placeholder: '',
                name: 'visitor_gender',
                label: 'Gender',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: 'Gender is required.'
                    }
                },
                options: [
                    {
                        label: 'Male',
                        value: 'male'
                    },
                    {
                        label: 'Female',
                        value: 'female'
                    },
                    {
                        label: 'Both',
                        value: 'both'
                    }
                ]
            },
            visitor_behavior_type: {
                placeholder: '',
                name: 'visitor_behavior_type',
                label: 'Visitor Behavior',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: 'Visitor Behavior is required.'
                    }
                },
                options: [
                    {
                        label: 'Browser',
                        value: 'browser'
                    },
                    {
                        label: 'Cart abandoner',
                        value: 'cartAbandoner'
                    },
                    {
                        label: 'Purchaser',
                        value: 'purchaser'
                    },
                    {
                        label: 'All',
                        value: 'all'
                    }
                ]
            }
        }
    };
};

export const initB2BMediaVisitorSegmentData = function () {
    return {
        data: {
            id: '',
            campaign_setting_id: '',
            visitor_type: 'newVisitor',
            visitor_member_type: 'newMember',
            visitor_gender: 'both',
            visitor_behavior_type: 'all'
        },
        fieldConfigurations: {
            visitor_type: {
                placeholder: '',
                name: 'visitor_type',
                //label: 'Visitor Type',
                label: '',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: 'Visitor type is required.'
                    }
                },
                options: [
                    {
                        label: 'New visitor',
                        value: 'newVisitor'
                    },
                    {
                        label: 'Returning visitor',
                        value: 'returningVisitor'
                    },
                    {
                        label: 'All',
                        value: 'both'
                    }
                ]
            },
          
        }
    };
};

export const initEcommerceReturningCustomerSegmentation = function () {
    return {
        fieldConfigurations: {
            placeholder: '',
            name: 'returning_visitor_type',
            label: 'Returning Visitor Type',
            fieldClass: {
                    'invalid-field': false
            },
            options: [
            {
             
                    placeholder: '',
                    name: 'browsers',
                    label: 'Browsers',
                    select:false,
                    fieldClass: {
                        'invalid-field': false
                    },
                    validations: {
                        rule: {
                            required: false
                        },
                        messages: {
                            required: ''
                        }
                    }
              
            },
            {
              
                    placeholder: '',
                    name: 'prospects',
                    label: 'Prospects',
                    select:false,
                    fieldClass: {
                        'invalid-field': false
                    },
                    validations: {
                        rule: {
                            required: false
                        },
                        messages: {
                            required: ''
                        }
                    }
               
            },
            {
              
                    placeholder: '',
                    name: 'oneTimePurchaser',
                    label: 'One Time Purchaser',
                    select:false,
                    fieldClass: {
                        'invalid-field': false
                    },
                    validations: {
                        rule: {
                            required: false
                        },
                        messages: {
                            required: ''
                        }
                    }
              
            },
            {
               
                    placeholder: '',
                    name: 'repeatPurchasers',
                    label: 'Repeat Purchasers',
                    select:false,
                    fieldClass: {
                        'invalid-field': false
                    },
                    validations: {
                        rule: {
                            required: false
                        },
                        messages: {
                            required: ''
                        }
                    }
              
            },
            {
           
                    placeholder: '',
                    name: 'loyalCustomers',
                    label: 'Loyal Customers',
                    select:false,
                    fieldClass: {
                        'invalid-field': false
                    },
                    validations: {
                        rule: {
                            required: false
                        },
                        messages: {
                            required: ''
                        }
                    }
              
            },
            {
              
                    placeholder: '',
                    name: 'all',
                    label: 'All',
                    select:true,
                    fieldClass: {
                        'invalid-field': false
                    },
                    validations: {
                        rule: {
                            required: false
                        },
                        messages: {
                            required: ''
                        }
                    }
               
            }
            ]
        
        }
    };
};
